// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./hotmart-home-tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --loader-background: var(--color-grey-20);
  --loader-color: var(--color-green-100);
}

#hotmart-cookie_alert-component {
  box-sizing: border-box;
  padding: var(--space-12);
  max-width: 1440px;
  width: calc(100% - 2 * var(--space-12));
}

/* ALERT */
.cookie-alert-container {
  background: var(--color-gray-organic);
  padding: var(--space-16);
  border-radius: var(--size-8);
  font-family: 'Nunito Sans', arial, sans-serif;
  box-shadow: -1px 4px 6px rgba(0, 0, 0, 0.25), -1px -1px 10px rgba(0, 0, 0, 0.2);
}

.cookie-alert-container > div {
  display: grid;
  grid-template-areas:
    'body buttons'
    'body buttons';
  grid-template-columns: minmax(auto, 10fr) minmax(auto, 2fr);
  gap: 0 1rem;
}

/* header */
.cookie-alert-container-header {
  grid-area: header;
  display: none;
  justify-content: space-between;
  align-items: start;
}

.cookie-alert-container-title {
  font-family: 'Nunito Sans', aria, sans-serif;
  color: var(--color-grey-100);
  font-weight: var(--font-weight-500);
  font-size: var(--size-14);
  line-height: var(--line-height-150);
  margin: 0;
  display: none;
}

.cookie-policy-close {
  display: none;
  border: none;
  background-color: transparent;
  color: var(--color-grey-30);
}

/* body */
.cookie-alert-container-body-text {
  grid-area: body;
  align-items: center;
  display: flex;
  color: var(--color-grey-100);
  margin-bottom: 0;
  text-align: left;
}

.cookie-alert-container-body-text p {
  color: var(--color-text-organic);
  font-feature-settings: 'liga';
  font-weight: var(--font-weight-400);
  font-size: var(--font-size-14);
  line-height: 1.3;
  margin: 0;
}

.cookie-alert-container-body a {
  color: var(--color-blue-organic);
}

/* footer */
.cookie-policy-footer {
  align-items: center;
  display: flex;
  gap: 0 1rem;
  grid-area: buttons;
  justify-content: center;
}

.cookie-policy-button {
  cursor: pointer;
  margin: 0 !important;
  padding: var(--size-12);

  border-style: solid;
  border-radius: var(--size-6);
  border-width: 0;
  font-size: var(--font-size-14);
  font-weight: var(--font-weight-500);
  line-height: var(--line-height-125);
  background-color: var(--color-blue-organic);
  border-color: var(--color-blue-organic);
  color: var(--color-white);
  white-space: nowrap;
}

#hotmart-cookie_alert-component .cookie-policy-footer .cookie-policy-accept-all {
  min-width: 11rem;
}

.cookie-policy-button.cookie-policy-ok {
  padding: var(--size-12);
  font-size: var(--font-size-14);
}

.cookie-policy-button:hover {
  background-color: var(--color-blue-120);
  border-color: var(--color-blue-120);
}

a {
  color: var(--color-blue-organic);
}

a:hover {
  color: var(--color-blue-120);
}

/* ConfirmModal */
.hotmart-cookie-modal-configuration {
  background-color: var(--color-white);
  font-family: 'Nunito Sans', arial, sans-serif;
  border-radius: 5px;
  box-shadow: 0 5px 40px rgb(0, 0, 0, 0.16);
}

.cookie-banner-modal-title {
  font-family: 'Nunito Sans', aria, sans-serif;
  font-feature-settings: 'liga';
  color: var(--color-grey-100);
  font-weight: var(--font-weight-300);
  font-size: var(--font-size-32);
  margin-top: 0;
}

.cookie-banner-modal-description,
.cookie-banner-category-form-label,
.cookie-banner-category-description {
  font-weight: var(--font-weight-400);
  font-size: var(--font-size-16);
  line-height: 1.5;
  margin-top: 0;
  color: var(--color-grey-70);
}

.cookie-banner-category-form-label {
  font-size: var(--font-size-18);
  color: var(--color-grey-80);
}

.cookie-banner-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.cookie-banner-category-table {
  border-collapse: collapse;
  margin-top: var(--size-8);
  margin-left: var(--size-8);
}

.cookie-banner-category-table th {
  padding: var(--size-8);
  color: var(--color-grey-90);
}

.cookie-banner-category-table td {
  padding: var(--size-8);
  color: var(--color-grey-80);
  vertical-align: top;
}

.cookie-banner-category-table tbody tr:hover {
  background-color: var(--color-green-20);
}

.hotmart-cookie-modal-configuration input[type='checkbox'] {
  accent-color: var(--color-green-100);
}

#hotmart-cookie_alert-component .cookie-policy-footer button {
  transition: all ease-in-out 0.25s;
}

#hotmart-cookie_alert-component .cookie-policy-go-to-configuration {
  background-color: var(--color-grey-6);
  color: var(--color-blue-organic);
}

#hotmart-cookie_alert-component .cookie-policy-go-to-configuration:hover {
  background-color: var(--color-grey-12);
}

#hotmart-cookie_alert-component .cookie-policy-footer button:last-of-type {
  margin-right: 0;
}

/* tablets and small desktop */
@media all and (max-width: 991px) {
  #hotmart-cookie_alert-component .cookie-alert-container > div {
    display: grid;
    grid-template-areas: 'body buttons';
    grid-template-columns: 1fr;
    gap: 0.75rem 1rem;
  }

  #hotmart-cookie_alert-component .cookie-policy-body-text {
    align-items: center;
    display: flex;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    justify-content: center;
  }

  #hotmart-cookie_alert-component .cookie-policy-button {
    font-size: 0.812rem;
    margin: 0 !important;
    padding: var(--size-8);
    white-space: wrap;
    width: 100%;
  }
}

/* mobile */
@media all and (max-width: 576px) {
  #hotmart-cookie_alert-component {
    margin: 0 var(--space-12);
    padding: 0;
  }

  #hotmart-cookie_alert-component .cookie-alert-container > div {
    display: initial;
  }

  #hotmart-cookie_alert-component .cookie-alert-container {
    padding: var(--space-16);
  }

  #hotmart-cookie_alert-component .cookie-alert-container-title {
    display: none;
  }

  #hotmart-cookie_alert-component .cookie-alert-container-body-text {
    margin-bottom: 0.75rem !important;
    text-align: left;
  }

  #hotmart-cookie_alert-component .cookie-alert-container-body-text {
    margin: 0;
  }
  .cookie-alert-container-body-text p {
    font-size: var(--font-size-11);
  }

  #hotmart-cookie_alert-component .cookie-policy-footer {
    flex-direction: column;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button {
    width: 100%;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button {
    margin-right: 0;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer .cookie-policy-accept-all {
    min-width: initial !important;
  }

  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button:not(.cookie-policy-ok) {
    margin-top: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/cookie-banner/implementations/hotmart-home/style.css"],"names":[],"mappings":"AAEA;EACE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,wBAAwB;EACxB,4BAA4B;EAC5B,6CAA6C;EAC7C,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb;;kBAEgB;EAChB,2DAA2D;EAC3D,WAAW;AACb;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,mCAAmC;EACnC,yBAAyB;EACzB,mCAAmC;EACnC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,uBAAuB;;EAEvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,8BAA8B;EAC9B,mCAAmC;EACnC,mCAAmC;EACnC,2CAA2C;EAC3C,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,4BAA4B;EAC5B,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;;EAGE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;IACb,mCAAmC;IACnC,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;EACA;IACE,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["@import './hotmart-home-tokens.css';\n\n:host {\n  --loader-background: var(--color-grey-20);\n  --loader-color: var(--color-green-100);\n}\n\n#hotmart-cookie_alert-component {\n  box-sizing: border-box;\n  padding: var(--space-12);\n  max-width: 1440px;\n  width: calc(100% - 2 * var(--space-12));\n}\n\n/* ALERT */\n.cookie-alert-container {\n  background: var(--color-gray-organic);\n  padding: var(--space-16);\n  border-radius: var(--size-8);\n  font-family: 'Nunito Sans', arial, sans-serif;\n  box-shadow: -1px 4px 6px rgba(0, 0, 0, 0.25), -1px -1px 10px rgba(0, 0, 0, 0.2);\n}\n\n.cookie-alert-container > div {\n  display: grid;\n  grid-template-areas:\n    'body buttons'\n    'body buttons';\n  grid-template-columns: minmax(auto, 10fr) minmax(auto, 2fr);\n  gap: 0 1rem;\n}\n\n/* header */\n.cookie-alert-container-header {\n  grid-area: header;\n  display: none;\n  justify-content: space-between;\n  align-items: start;\n}\n\n.cookie-alert-container-title {\n  font-family: 'Nunito Sans', aria, sans-serif;\n  color: var(--color-grey-100);\n  font-weight: var(--font-weight-500);\n  font-size: var(--size-14);\n  line-height: var(--line-height-150);\n  margin: 0;\n  display: none;\n}\n\n.cookie-policy-close {\n  display: none;\n  border: none;\n  background-color: transparent;\n  color: var(--color-grey-30);\n}\n\n/* body */\n.cookie-alert-container-body-text {\n  grid-area: body;\n  align-items: center;\n  display: flex;\n  color: var(--color-grey-100);\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.cookie-alert-container-body-text p {\n  color: var(--color-text-organic);\n  font-feature-settings: 'liga';\n  font-weight: var(--font-weight-400);\n  font-size: var(--font-size-14);\n  line-height: 1.3;\n  margin: 0;\n}\n\n.cookie-alert-container-body a {\n  color: var(--color-blue-organic);\n}\n\n/* footer */\n.cookie-policy-footer {\n  align-items: center;\n  display: flex;\n  gap: 0 1rem;\n  grid-area: buttons;\n  justify-content: center;\n}\n\n.cookie-policy-button {\n  cursor: pointer;\n  margin: 0 !important;\n  padding: var(--size-12);\n\n  border-style: solid;\n  border-radius: var(--size-6);\n  border-width: 0;\n  font-size: var(--font-size-14);\n  font-weight: var(--font-weight-500);\n  line-height: var(--line-height-125);\n  background-color: var(--color-blue-organic);\n  border-color: var(--color-blue-organic);\n  color: var(--color-white);\n  white-space: nowrap;\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer .cookie-policy-accept-all {\n  min-width: 11rem;\n}\n\n.cookie-policy-button.cookie-policy-ok {\n  padding: var(--size-12);\n  font-size: var(--font-size-14);\n}\n\n.cookie-policy-button:hover {\n  background-color: var(--color-blue-120);\n  border-color: var(--color-blue-120);\n}\n\na {\n  color: var(--color-blue-organic);\n}\n\na:hover {\n  color: var(--color-blue-120);\n}\n\n/* ConfirmModal */\n.hotmart-cookie-modal-configuration {\n  background-color: var(--color-white);\n  font-family: 'Nunito Sans', arial, sans-serif;\n  border-radius: 5px;\n  box-shadow: 0 5px 40px rgb(0, 0, 0, 0.16);\n}\n\n.cookie-banner-modal-title {\n  font-family: 'Nunito Sans', aria, sans-serif;\n  font-feature-settings: 'liga';\n  color: var(--color-grey-100);\n  font-weight: var(--font-weight-300);\n  font-size: var(--font-size-32);\n  margin-top: 0;\n}\n\n.cookie-banner-modal-description,\n.cookie-banner-category-form-label,\n.cookie-banner-category-description {\n  font-weight: var(--font-weight-400);\n  font-size: var(--font-size-16);\n  line-height: 1.5;\n  margin-top: 0;\n  color: var(--color-grey-70);\n}\n\n.cookie-banner-category-form-label {\n  font-size: var(--font-size-18);\n  color: var(--color-grey-80);\n}\n\n.cookie-banner-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.cookie-banner-category-table {\n  border-collapse: collapse;\n  margin-top: var(--size-8);\n  margin-left: var(--size-8);\n}\n\n.cookie-banner-category-table th {\n  padding: var(--size-8);\n  color: var(--color-grey-90);\n}\n\n.cookie-banner-category-table td {\n  padding: var(--size-8);\n  color: var(--color-grey-80);\n  vertical-align: top;\n}\n\n.cookie-banner-category-table tbody tr:hover {\n  background-color: var(--color-green-20);\n}\n\n.hotmart-cookie-modal-configuration input[type='checkbox'] {\n  accent-color: var(--color-green-100);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer button {\n  transition: all ease-in-out 0.25s;\n}\n\n#hotmart-cookie_alert-component .cookie-policy-go-to-configuration {\n  background-color: var(--color-grey-6);\n  color: var(--color-blue-organic);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-go-to-configuration:hover {\n  background-color: var(--color-grey-12);\n}\n\n#hotmart-cookie_alert-component .cookie-policy-footer button:last-of-type {\n  margin-right: 0;\n}\n\n/* tablets and small desktop */\n@media all and (max-width: 991px) {\n  #hotmart-cookie_alert-component .cookie-alert-container > div {\n    display: grid;\n    grid-template-areas: 'body buttons';\n    grid-template-columns: 1fr;\n    gap: 0.75rem 1rem;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-body-text {\n    align-items: center;\n    display: flex;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    justify-content: center;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-button {\n    font-size: 0.812rem;\n    margin: 0 !important;\n    padding: var(--size-8);\n    white-space: wrap;\n    width: 100%;\n  }\n}\n\n/* mobile */\n@media all and (max-width: 576px) {\n  #hotmart-cookie_alert-component {\n    margin: 0 var(--space-12);\n    padding: 0;\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container > div {\n    display: initial;\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container {\n    padding: var(--space-16);\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container-title {\n    display: none;\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container-body-text {\n    margin-bottom: 0.75rem !important;\n    text-align: left;\n  }\n\n  #hotmart-cookie_alert-component .cookie-alert-container-body-text {\n    margin: 0;\n  }\n  .cookie-alert-container-body-text p {\n    font-size: var(--font-size-11);\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer {\n    flex-direction: column;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button {\n    width: 100%;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button {\n    margin-right: 0;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer .cookie-policy-accept-all {\n    min-width: initial !important;\n  }\n\n  #hotmart-cookie_alert-component .cookie-policy-footer button:not(.hidden) ~ button:not(.cookie-policy-ok) {\n    margin-top: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
